import { render, staticRenderFns } from "./gc-image-upload.vue?vue&type=template&id=794df9c6&"
import script from "./gc-image-upload.vue?vue&type=script&lang=js&"
export * from "./gc-image-upload.vue?vue&type=script&lang=js&"
import style0 from "./gc-image-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports